import React from 'react';

import { FlexColumn } from 'ui-components/components/flex';

import { TransferOrderProgressBar } from '../../transfer-order-progress-bar/transfer-order-progress-bar';
import styles from './styles.module.less';

type ReceivedColumnProps = {
  data: Record<string, unknown>;
};

export const ReceivedColumn = ({ data }: ReceivedColumnProps) => {
  const quantity = (data.quantity as number) || 0;
  const totalReceived = (data.totalReceived as number) || 0;
  const totalRejected = (data.totalRejected as number) || 0;

  return (
    <FlexColumn className={styles['received-column']}>
      <TransferOrderProgressBar receivedItems={totalReceived} rejectedItems={totalRejected} renderWithoutItemsCopy totalItems={quantity} />
    </FlexColumn>
  );
};
